const MIN_DEPOSIT_PERCENTAGE = 0.20
const MAX_DEPOSIT_PERCENTAGE = 0.75

const INTEREST_RATE_DEFAULT = 0.22
// const INTEREST_RATE_PLUS_4 = 0.29
// const INTEREST_RATE_ANSWER_YES_AND_NO_OR_AGE_5_PLUS = 0.4
const FEE_AUTO_INSURANCE = 0.05

const MONTH_OPTIONS = [
  { months: 12 },
  { months: 24, maxAge: 8 },
  { months: 36, maxAge: 7 },
  { months: 48, maxAge: 6 },
  { months: 60, maxAge: 5 },
]

const useFinancing = (
  vehicle, deposit = 0,
  // credit = 'Si',
  // goodCreditHistory = 'No'
) => {
  const { price } = vehicle
  const vehiclePrice = Number(price)
  // const age = new Date().getFullYear() - year

  const amount = vehiclePrice - deposit
  const totalAmountToFinancing = amount

  const rate = INTEREST_RATE_DEFAULT
  // if (credit === 'Si' && (goodCreditHistory === 'No') && age <= 4) {
  //   rate = INTEREST_RATE_DEFAULT
  // } else if (credit === 'Si' && (goodCreditHistory === 'No') && age > 4) {
  //   rate = INTEREST_RATE_PLUS_4
  // }

  const monthlyRate = rate / 12

  const autoInsurance = Math.ceil((vehiclePrice * FEE_AUTO_INSURANCE) / 12)
  const getMonthlyInstallment = (months) => {
    return Math.ceil(
      // eslint-disable-next-line no-restricted-properties
      ((amount * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -1 * months))) / 100,
    ) * 100
  }

  const monthOptions = MONTH_OPTIONS
  const allowedMonths = monthOptions

  const financingOptions = allowedMonths.sort(
    ((a, b) => (a.months > b.months ? -1 : 1)),
  ).map(({ months }) => ({
    months,
    value: getMonthlyInstallment(months),
  }))

  return {
    amount: Math.ceil(amount * 1000) / 1000,
    totalAmountToFinancing: Math.ceil(totalAmountToFinancing * 1000) / 1000,
    rate,
    financingOptions,
    autoInsurance,
  }
}

export const getMinMaxDeposit = (vehiclePrice, vehicleYear, monthlyPayment = 12, credit = 'Si', goodCreditHistory = 'Si') => {
  let minDepositPercetange = MIN_DEPOSIT_PERCENTAGE
  const age = new Date().getFullYear() - vehicleYear

  if ((credit === 'No') || ((credit === null) && (goodCreditHistory === 'Si' || goodCreditHistory === 'No')) || (credit === null && goodCreditHistory === null) || (credit === 'Si' && goodCreditHistory === null) || (credit === 'Si' && goodCreditHistory === 'No')) {
    minDepositPercetange = MIN_DEPOSIT_PERCENTAGE
  } else if ((credit === 'Si' && goodCreditHistory === 'Si')) {
    if (age <= 4 && monthlyPayment <= 36) {
      minDepositPercetange = 0.10
    } else if (age > 4) {
      minDepositPercetange = MIN_DEPOSIT_PERCENTAGE
    }
  }

  const maxDeposit = vehiclePrice * MAX_DEPOSIT_PERCENTAGE
  const minDeposit = vehiclePrice * minDepositPercetange

  return {
    minDeposit: Math.ceil(minDeposit / 1000) * 1000,
    maxDeposit: Math.ceil(maxDeposit / 1000) * 1000,
    defaultDeposit: Math.ceil(minDeposit / 1000) * 1000,
    minDepositPercetange,
  }
}

export default useFinancing
